import type { BlockSerialized } from '#layers/block-engine/types/block';

/**
 * Create the variables object from a block definition.
 */
export function createBlockVariables(block: BlockSerialized) {
	const variables: Record<string, any> = {};

	for (const variable of block.variables ?? []) {
		try {
			let value: any = variable.defaultValue;

			if (variable.array) {
				value = value ? JSON.parse(value) : [];
			}
			else {
				switch (variable.type) {
					case 'number': {
						value = Number(value);

						break;
					}
					case 'boolean': {
						value = value !== 'false' && value !== '0' && value !== '';

						break;
					}
					case 'object': {
						value = JSON.parse(value);

						break;
					}
				// No default
				}
			}

			variables[variable.name] = value;
		}
		catch (error) {
			console.error(`Failed to parse variable ${variable.name} of block ${block.name}`);
			console.error(error);

			if (variable.array) {
				variables[variable.name] = [];
				continue;
			}

			switch (variable.type) {
				case 'number': {
					variables[variable.name] = 0;

					break;
				}
				case 'boolean': {
					variables[variable.name] = false;

					break;
				}
				case 'object': {
					variables[variable.name] = null;

					break;
				}
			// No default
			}
		}
	}

	return variables;
}
